// @flow
import type { Action } from '../actions/daysMap';

export type DaysMap = {
  mapState: ?('DAYS' | 'GROUPS')
};

export type State = DaysMap;

export default function currentUser(
  state: State = { mapState: null },
  action: Action
) {
  switch (action.type) {
    case 'SET_MAP_STATE': {
      const { mapState } = action;
      return {
        ...state,
        mapState
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
